import { Component } from 'react';
import { DirectoryPageDocument } from '@graphql/pages/directory.generated';
import { withServerSideProps } from '@lib/withServerSideProps';
import type { ServerSidePageProps } from '@lib/withServerSideProps';
import Page from '@ui/components/ams/Pages/Page';
import AMS from '@ui/components/ams';
import { mapDirectoryPageData } from '@lib/page-data/directory.map';
import type { DirectoryPageViewModel } from '@lib/page-data/directory.map';
import { PAGE_DIRECTORY } from '@lib/constants';
import { ATM_CONSTANTS, pushPageViewEvent } from '@lib/atm';

class DirectoryPage extends Component<ServerSidePageProps<DirectoryPageViewModel>> {
  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
    } = this.props;

    pushPageViewEvent(
      window,
      userData,
      {
        locale,
        sections: [PAGE_DIRECTORY],
        pageCategory: ATM_CONSTANTS.categories.page,
      },
    );
  }

  render() {
    const {
      globalPageData,
      pageData,
      userSessionData,
      requestData,
      locale,
    } = this.props;

    const {
      shopOrder,
      globalShopConfig,
      allCategories,
      globalPageConfig,
      directoryPageTitle,
      globalCategoryConfig,
      pageAds,
      directoryAdToDisplay,
    } = pageData;

    return (
      <Page
        analyticsPageName={PAGE_DIRECTORY}
        pageTitle={directoryPageTitle}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
        pageAds={pageAds}
      >
        <AMS.DirectoryContent
          locale={locale}
          userShopsData={userSessionData.userShopsData}
          userData={userSessionData.userData}
          shopOrder={shopOrder}
          globalPageConfig={globalPageConfig}
          globalShopConfig={globalShopConfig}
          globalCategoryConfig={globalCategoryConfig}
          allCategories={allCategories}
          googleAd={directoryAdToDisplay}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: DirectoryPageDocument,
  pageDataMapper: mapDirectoryPageData,
});

export default DirectoryPage;
